import React from 'react';

import { getClickAttrs } from '../../Analytics/gtag';
import { navigationIDs } from '../../Analytics/testIDConfig';
import Img from '../../Img';
import HeaderMenu from '../../HeaderMenu';

import styles from '../header.scss';

const MobilePostButton = ({ plusButtonOptions, optionSelected, toggleHeaderMenu, selected, iconUnselected, iconSelected }) => {
    return (
        <HeaderMenu
            options={plusButtonOptions}
            showFullWidth={true}
            onOptionSelected={optionSelected}
            menuOpened={toggleHeaderMenu}
            menuClosed={toggleHeaderMenu}
            {...getClickAttrs({
                category: 'Header post score Menu',
                context: 'Header menu Button Click',
                location: 'Header Nav Top',
                testid: `${navigationIDs.postScoreMobile.component}-${navigationIDs.postScoreMobile.location}-${navigationIDs.postScoreMobile.id}`,
            })}
        >
            <div className={styles.navIconLink}>
                <Img alt="post icon" src={`${selected ? iconSelected : iconUnselected}`} />
                <div className={`title ${selected ? 'text-bold' : ''}`}>
                    Post
                </div>
            </div>
        </HeaderMenu>
    );
};

export default MobilePostButton;
